/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import StorefrontRoundedIcon from "@mui/icons-material/StorefrontRounded";
import { useLandingPageStyles } from "./index.style";
import { Grid } from "@mui/material";
import appLogo from "../../assets/images/svg/appLogo.svg";
import { Website_url } from "../../connections";

const LandingPage = () => {
  const classes1 = useLandingPageStyles();
  const navigate = useNavigate();

  const [mobileView, setMobileView] = useState(false);
  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < 767
        ? setMobileView(true)
        : setMobileView(false);
    };
    setResponsiveness();
    window.addEventListener("resize", () => setResponsiveness());

    return () => {
      window.removeEventListener("resize", () => setResponsiveness());
    };
  }, []);

  const redirectToLogin = () => {
    navigate("/login");
  };
  return (
    <Grid item container style={{ width: "100%", height: "100vh" }}>
      <Grid item xs={12} md={6} css={classes1.columnOne}>
        <div css={classes1.columnTwodetail}>
          <div style={{ width: "50%", maxidth: "300px", marginBottom: "5%" }}>
            <img src={appLogo} alt="money mails logo" />
          </div>

          <div>
            <h6 css={classes1.middleheading}>
              Login now and start earning money for every email that you view!
            </h6>
          </div>

          <div css={classes1.middleheading1}>
            Rewards in Every Message Earn While You Learn in Money Mails
          </div>

          <button
            css={classes1.primaryCta}
            onClick={() => {
              redirectToLogin();
            }}
            type="button"
          >
            <span>Login and Redeem your Rewards</span>
            <ArrowForwardIcon />
          </button>
        </div>
      </Grid>

      {/* ── stylish vertical divider ── */}
      {!mobileView && (
        <div css={classes1.verticalDivider}>
          <div css={classes1.dividerLine} />
          <div css={classes1.dividerBadge}>OR</div>
          <div css={classes1.dividerLine} />
        </div>
      )}

      {!mobileView && (
        <Grid item xs css={classes1.columnTwo}>
          <div css={classes1.columnTwodetail}>
            <div css={classes1.businessRow}>
              <div css={classes1.businessIcon}>
                <StorefrontRoundedIcon />
              </div>
              <h1 style={{ color: "#fff", margin: 0 }}>Business Owner</h1>
            </div>
            <div>
              <h5 css={classes1.middle}>
                Join Money Mails, Boost your sales, Get the help you need.
              </h5>
              <h5 css={classes1.middle1}>
                {" "}
                Connect, Collaborate, Conquer Vendor Access Awaits
              </h5>
              <h6 css={classes1.middle2}>
                {" "}
                Swift your Approvals, Contact Admin
              </h6>
            </div>

            <div css={classes1.Loginbutton}>
              <a href={`${Website_url}/login`} target="_blank">
                <div css={classes1.secondaryCta}>
                  <span>Click here to Login</span>
                  <ArrowForwardIcon />
                </div>
              </a>
            </div>
          </div>
        </Grid>
      )}
      {mobileView && (
        <Grid item xs={12} md={6} css={classes1.columnTwo}>
          <div css={classes1.columnTwodetail}>
            <div css={classes1.businessRow}>
              <div css={classes1.businessIcon}>
                <StorefrontRoundedIcon />
              </div>
              <h1 style={{ color: "#fff", margin: 0 }}>Business Owner</h1>
            </div>
            <div>
              <h5 css={classes1.middlemobile}>
                Join Money Mails, Boost your sales, Get the help you need.
              </h5>
              <h5 css={classes1.middle1mobile}>
                {" "}
                Connect, Collaborate, Conquer Vendor Access Awaits
              </h5>
              <h6 css={classes1.middle2mobile}>
                {" "}
                Swift your Approvals, Contact Admin
              </h6>
            </div>

            <div css={classes1.Loginbutton}>
              <a href={`${Website_url}/login`} target="_blank">
                <div css={classes1.secondaryCta}>
                  <span>Click here to Login</span>
                  <ArrowForwardIcon />
                </div>
              </a>
            </div>
          </div>
        </Grid>
      )}
    </Grid>
  );
};

export default LandingPage;
